import { useNavigate } from 'react-router-dom';

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return '좋은 아침이에요';
  if (h < 18) return '안녕하세요';
  return '수고 많으셨어요';
}

function getDateStr() {
  const d = new Date();
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일 ${days[d.getDay()]}요일`;
}

const MENU_ITEMS = [
  { key: 'invoice', label: '송장 등록', icon: '🚚', path: '/m/invoice', enabled: true },
  { key: 'sales', label: '매출 현황', icon: '📊', path: '/m/sales', enabled: false },
  { key: 'send', label: '상품 전송', icon: '📤', path: '/m/send', enabled: false },
];

export default function MobileHome() {
  const navigate = useNavigate();
  const username = localStorage.getItem('mobile_username') || 'admin';

  const handleLogout = () => {
    if (!window.confirm('로그아웃하시겠습니까?')) return;
    localStorage.removeItem('mobile_token');
    localStorage.removeItem('mobile_username');
    navigate('/m/login', { replace: true });
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: '20px', boxSizing: 'border-box' }}>
      <div style={{ marginBottom: '24px' }}>
        <div style={{ fontSize: '20px', fontWeight: '500', color: '#1a1a1a' }}>{getGreeting()}, {username}님</div>
        <div style={{ fontSize: '13px', color: '#999', marginTop: '2px' }}>{getDateStr()}</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        {MENU_ITEMS.map(item => (
          <button
            key={item.key}
            onClick={() => item.enabled && navigate(item.path)}
            disabled={!item.enabled}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
              padding: '28px 10px', borderRadius: '14px', border: 'none',
              background: item.enabled ? '#fff' : '#eee',
              opacity: item.enabled ? 1 : 0.5,
              boxSizing: 'border-box',
            }}
          >
            <span style={{ fontSize: '28px' }}>{item.icon}</span>
            <span style={{ fontSize: '14px', color: '#1a1a1a', fontWeight: '500' }}>{item.label}</span>
            {!item.enabled && <span style={{ fontSize: '10px', color: '#aaa' }}>준비 중</span>}
          </button>
        ))}
      </div>

      <div style={{ marginTop: '32px', paddingTop: '16px', borderTop: '1px solid #e0e0e0' }}>
        <button onClick={handleLogout} style={{ width: '100%', fontSize: '13px', padding: '12px', borderRadius: '10px', border: 'none', background: 'transparent', color: '#999' }}>
          로그아웃
        </button>
      </div>
    </div>
  );
}
